// extracted by mini-css-extract-plugin
export default {"radio":"radio_radio__MVV7a"};